import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import {
    GetLookupData, GetSalesOrderGridData
} from "../../../../services/SalesOrderService";
import EdiWebSearchResult from "./EdiWebSearchResult";
import EdiWebFilters from "./EdiWebFilters";
import salesOrderSearchFormLayout from "../salesOrdersTab/SalesOrderSearchFormLayout";

const EdiWebTab = (props) => {
    const orderStatus = '2';
    const EdiWebSearchUrl = "om/SaleOrder/EdiWebSearch";
    const [dataSource, setDataSource] = useState(null);
    var accessToken = props.oidc.user.access_token;
    const searchData =  (formFields) => {
        var resultData =  GetSalesOrderGridData(accessToken, EdiWebSearchUrl, formFields, orderStatus,salesOrderSearchFormLayout);
        setDataSource(resultData);
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <EdiWebFilters searchData={searchData}/>
                        <EdiWebSearchResult
                            data={dataSource}
                        />        
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(EdiWebTab);